<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">

      <v-data-table :headers="headers" :items="status_array_list" class="elevation-1 mytable" dense :search="search">

        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Clearance Status Master</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"></span>

          <v-row dense align="center">
            
            <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
              <v-btn
                rounded
                color="success"
                outlined
                :loading="loader"
                @click="downloadFile"
              >
                <v-icon left color="success">mdi-export</v-icon>
                Export
              </v-btn>
            </v-col>

            <!-- Search -->
            <v-col class="mr-8" sm="6" md="5" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details />
            </v-col>

            <!-- Add Status (Dialog ONLY) -->
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" small v-on="on">
                  Add Clearance Status
                </v-btn>
              </template>

              <!-- Dialog Content -->
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text class="pb-2 mt-2">
                    <v-text-field label="Name" v-model="status_name" outlined />
                  </v-card-text>

                  <v-col cols="12" sm="6" md="4" class="ml-4 mt-0" v-if='editedIndex != -1'>
                    <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                  </v-col>

                  <v-card-actions class="justify-center pt-0">
                    <v-btn class="button" @click="close()" :disabled="!valid">
                       Cancel
                    </v-btn>

                    <v-btn color="primary button" @click="save" :disabled="!valid">
                        {{ editedIndex === -1 ? 'Add' : 'Update' }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>

        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>

            <v-avatar size="25" class="delete-avatar ml-2">
              <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
            </v-avatar>
          </div>
        </template>
        <template v-slot:item.isactive="{ item }">
          <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)"></v-switch>
        </template>
      </v-data-table>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    status_name: "",
    dialog: false,
    headers: [
      {
        text: "Status Name",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Status",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: " Actions", value: "action", sortable: false },
    ],
    status_array_list: [],
    status_super_master_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      name: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      name: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Clearance status" : "Edit Clearance Status";
    },
    filteredStatusList() {
    if (!this.search) return this.status_array_list;

    const txt = this.search.toLowerCase();

    return this.status_array_list.filter(item =>
      (item.name || "").toLowerCase().includes(txt)
    );
  }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    downloadFile() {
    this.loader = true;

    const excelData = this.filteredStatusList.map((item, index) => ({
      "S.No": index + 1,
      "Name": item.name,
      "Status": item.isactive ? "Active" : "Inactive"
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Clearance Status");
    XLSX.writeFile(workbook, "clearance_status.xlsx");

    this.loader = false;
  },

    editItem(item) {
      this.editedIndex = this.status_array_list.indexOf(item);
      this.editedItem= {
        id : item.id,
        name : item.name,
        isactive : item.isactive
      };
      this.status_name = item.name;
      this.dialog = true;
    },

    onLoad() {
      this.overlay = true;
      this.status_name="";
      axios
        .post("/Dues/getStatus")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.overlay = false;
            this.status_array_list = res.data.clearance_status_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      this.status_name="";
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
              if(this.status_name){
                this.editedItem.name = this.status_name;
              }else{
                 this.showSnackbar("#b71c1c", "Enter valid status name");
                 return
              }    
          axios
            .post("/Dues/editStatus", this.editedItem)
            .then((res) => {
              if (res.data.code == "SUCCESS") {
                this.showSnackbar("#4caf50", "Status Updated Successfully...");
                this.close();
                this.onLoad();
              } else if (res.data.code == "NA") {
                this.showSnackbar("#b71c1c", "Status Already Present!!!");
              } else {
                this.showSnackbar("#b71c1c", "Something went wrong!");
                sessionStorage.setItem("error-trace", res.data.error_trace);
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
        }
      } else {
        if(this.status_name){
        const payload = {
          status_name: this.status_name
        }
        axios
          .post("/Dues/saveStatus", payload)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              this.showSnackbar("#4caf50", "Status Added Successfully...");
              this.onLoad();
            } else if (res.data.code == "NA") {
              this.showSnackbar("#b71c1c", "Status Already Present!!!");
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong...");
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
          this.close();
        }else{
          this.showSnackbar("#b71c1c", "Enter Clearance Status Name...");
        }

      }
    }, 

    isValidated() {
      if (this.editedItem.name) {
        return true;
      } else {
        if (!this.editedItem.name) {
          this.errorMsg.name = true;
        }

        return false;
      }
    }, 

    toggle(item) {
      const data = {
        status_id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/Dues/toggleStatus", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Status Changed!");
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong, Please try again later!"
            );
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this status?")) {
      const data = {
        status_id: item.id
      };
      axios
        .post("/Dues/deleteStatus", data)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Status Deleted Successfully...");
            this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      }
      this.close();
    }


  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.mytable /deep/ thead th {
  background: #0f2027;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>